module.exports = __webpack_public_path__ + "img/03.2b3ea155.jpg";